import { render, staticRenderFns } from "./ItemToolkitIndex.vue?vue&type=template&id=223735e2&scoped=true&"
import script from "./ItemToolkitIndex.vue?vue&type=script&lang=js&"
export * from "./ItemToolkitIndex.vue?vue&type=script&lang=js&"
import style0 from "./ItemToolkitIndex.vue?vue&type=style&index=0&id=223735e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223735e2",
  null
  
)

export default component.exports